import { Selector } from '@ngxs/store';
import { SportsState, SportsStateModel } from './sports.state';
import { SportDefinition, SportDefinitionResume } from '@smatchy/sdk';

export class SportsSelectors {
  @Selector([SportsState])
  static isLoadingActiveSports(state: SportsStateModel): boolean {
    return state.loadingActiveSports;
  }

  @Selector([SportsState])
  static backScreen(state: SportsStateModel): string {
    return state.backScreen;
  }

  @Selector([SportsState])
  static getActiveSports(state: SportsStateModel): SportDefinitionResume[] {
    return state.filteredActiveSports.sort((a, b) => (a.name > b.name ? 1 : -1));
  }

  /**
   * The full catalogue, unfiltered.
   *
   * getActiveSports returns filteredActiveSports, which shrinks as soon as
   * someone types in the sport search. Resolving an id against it would fail
   * exactly when the person found their sport by searching for it.
   */
  @Selector([SportsState])
  static getAllActiveSports(state: SportsStateModel): SportDefinitionResume[] {
    return state.allActiveSports ?? [];
  }

  @Selector([SportsState])
  static getActualSearch(state: SportsStateModel): string {
    return state.search;
  }

  @Selector([SportsState])
  static isLoadingCurrentSport(state: SportsStateModel): boolean {
    return state.loadingSingleSport;
  }

  @Selector([SportsState])
  /** null until a sport is opened, which is what the state's defaults set. */
  static getCurrentSport(state: SportsStateModel): SportDefinition | null {
    return state.currentSport;
  }
}
